import {
  DROP_SLOT_OVERSCAN,
  DROP_SLOT_ROW_HEIGHT,
  MAX_CHIP_COUNT,
  ORDER_SLOT_ROW_HEIGHT,
} from './pinned-board-constants';

export function useVariantSlotMetrics(remain: number, variantRemain: number, orderCount: number) {
  const effectiveRemain = Math.max(variantRemain ?? 0, remain ?? 0);
  const totalSlots = Math.max(1, Math.floor(effectiveRemain));
  const visibleCount = Math.min(totalSlots, MAX_CHIP_COUNT);
  const overflow = totalSlots - visibleCount;
  const rows = Array.from({ length: visibleCount }, (_, idx) => idx + 1);
  const orderRowsHeight = orderCount * ORDER_SLOT_ROW_HEIGHT;
  const nextDropSlotNo = orderCount + 1;

  return {
    effectiveRemain,
    overflow,
    rows,
    orderRowsHeight,
    nextDropSlotNo,
  };
}

export function computeDropSlotVirtualRange(args: {
  rows: number[];
  scrollTop: number;
  viewportHeight: number;
  orderRowsHeight: number;
}) {
  const { rows, scrollTop, viewportHeight, orderRowsHeight } = args;
  const dropScrollTop = Math.max(0, scrollTop - orderRowsHeight);
  const startIndex = Math.max(
    0,
    Math.floor(dropScrollTop / DROP_SLOT_ROW_HEIGHT) - DROP_SLOT_OVERSCAN,
  );
  const endIndex = Math.min(
    rows.length,
    Math.ceil((dropScrollTop + viewportHeight) / DROP_SLOT_ROW_HEIGHT) + DROP_SLOT_OVERSCAN,
  );

  return {
    startIndex,
    endIndex,
    offsetY: startIndex * DROP_SLOT_ROW_HEIGHT,
    totalHeight: rows.length * DROP_SLOT_ROW_HEIGHT,
    visibleRows: rows.slice(startIndex, endIndex),
  };
}
